var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAveragePasswordAgeInDaysCs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 30,
    viewBox: "0 0 21 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#AEB3B7",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.383 0v1.74H6.671V0H4.929v1.74H1.444v16.52h7.84v-1.738H3.187V7.826h15.682v8.696h-2.613v1.739h4.356V1.739h-3.485V0h-1.743zm1.743 5.217V3.478h1.742v2.609H3.186V3.478H4.93v1.74H6.67v-1.74h8.712v1.74h1.743z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.156 12.78V20h1.742v-6.693l.872-1.304.87 1.304V20h1.743v-7.22L12.77 8.867zM4.929 9.566h4.356v1.739H4.929zM4.929 13.044H6.67v1.739H4.93z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAveragePasswordAgeInDaysCs);
export default __webpack_public_path__ + "static/media/average-password-age-in-days-cs.4d8425b4.svg";
export { ForwardRef as ReactComponent };